import { render, staticRenderFns } from "./RoomCBTQuestionChoice.vue?vue&type=template&id=8c28d2fa&"
import script from "./RoomCBTQuestionChoice.vue?vue&type=script&lang=js&"
export * from "./RoomCBTQuestionChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c28d2fa')) {
      api.createRecord('8c28d2fa', component.options)
    } else {
      api.reload('8c28d2fa', component.options)
    }
    module.hot.accept("./RoomCBTQuestionChoice.vue?vue&type=template&id=8c28d2fa&", function () {
      api.rerender('8c28d2fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/CBT/RoomCBTQuestionChoice.vue"
export default component.exports